// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"a1486618","254":"0e09ab84","274":"5802b868","311":"ccf7abd3","372":"98891ba1","601":"3bb36a77","675":"4be3fc2a"}[chunkId] + ".chunk.js";
};